import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { ZoomSlider } from '../../components'
import WheelLoading from 'components/loading/wheel_loading'
import { ImageResizer } from 'views/slides/activities/matching_pairs/components'

import styles from './ImageCropper.scss'

import ThumbnailDeleteIcon from 'assets/global/delete-btn.svg'

class ImageCropper extends PureComponent {

	constructor() {
		super()
		this.state = {
			imageLoaded: false,
		}
		this.zoomHandler = this.zoomHandler.bind(this)
		this.cropper_size = 270
	}

	zoomHandler(scale) {
		this.props.changeImageMatrixHandler(
			[
				scale,
				0,
				0,
				scale,
				this.props.value.matrix[4],
				this.props.value.matrix[5],
			]
		)
	}

	positionChanged = (x, y) => {
		this.props.changeImageMatrixHandler(
			[
				this.props.value.matrix[0],
				0,
				0,
				this.props.value.matrix[3],
				x,
				y,
			]
		)
	}

	setupImage = (image_width, image_height) => {
		const imageProps = {
			container_width: 0,
			container_height: 0,
			imageRel: 0,
			containerRel: 0,
			imageScale: 1,
			xOffset: 0,
			yOffset: 0,
			isSmall: false,
			cropperSize: this.cropper_size,
			matrix: [],
		}
		if (image_width < this.cropper_size) {
			imageProps.isSmall = true
			this.cropper_size = image_width
		}
		imageProps.container_width = this.cropper_size
		imageProps.container_height = this.cropper_size
		if (this.props.value.matrix[0] === -1) {
			imageProps.imageRel = image_width / image_height
			imageProps.containerRel = imageProps.container_width / imageProps.container_height
			if (imageProps.imageRel > imageProps.containerRel) {
				imageProps.imageScale = (imageProps.container_width / image_width)
			} else {
				imageProps.imageScale = (imageProps.container_height / image_height)
			}
			if (imageProps.isSmall) {
				imageProps.xOffset = (imageProps.cropperSize - image_width) / 2
				imageProps.yOffset = (imageProps.cropperSize - image_height) / 2
			} else {
				imageProps.xOffset = (-image_width + imageProps.container_width) / 2
				imageProps.yOffset = (-image_height + imageProps.container_height) / 2
			}
			imageProps.matrix = [imageProps.imageScale, 0, 0, imageProps.imageScale, imageProps.xOffset, imageProps.yOffset]
			this.props.changeImageMatrixHandler(imageProps.matrix)
		}
		this.setState({ imageLoaded: true })
	}

	waitImageLoad(url) {
		const img = new Image

		img.onload = () => {
			this.props.imageLoadHandler(img.width, img.height)
			this.setupImage(img.width, img.height)
		}
		img.src = url
		// make sure the load event fires for cached images too
		if ( img.complete || img.complete === undefined ) {
			//img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=='
			img.src = url
			//this.setState({ imageLoaded: true })
		}
	}

	componentDidMount() {
		if (this.props.value.icon.versions.original !== undefined) {
			this.waitImageLoad(this.props.value.icon.versions.original)
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.value.icon.versions.original !== nextProps.value.icon.versions.original) {
			this.waitImageLoad(nextProps.value.icon.versions.original)
		}
	}

	render() {
		return (
			<div styleName="ImageCropper">
				<div styleName="ImageCropper-bar">
					{(this.props.value.icon.uploadId !== 0) &&
						<button
							styleName="ImageCropper-bar-delete"
							onClick={this.props.discardContentHandler}>
							<Isvg
								src={ThumbnailDeleteIcon}
								cacheGetRequests={true}
								styleName='ImageCropper-bar-delete-icon'
							/>
						</button>
					}
					{ (this.props.value.icon.id !== 0) && this.state.imageLoaded &&
						<Fragment>
							<hr styleName="ImageCropper-bar-separator" />
							<ZoomSlider
								scale={this.props.value.matrix[0]}
								onChange={this.zoomHandler}
							/>
						</Fragment>
					}
				</div>
				{ (this.props.value.icon.id !== 0) && this.state.imageLoaded &&
						<ImageResizer
							image={this.props.value.icon.versions.original}
							width={this.cropper_size}
							height={this.cropper_size}
							matrix={this.props.value.matrix}
							positionChanged={this.positionChanged}
						/>
			||
							<div styleName='ImageCropper-loading'>
								<div styleName='ImageCropper-loading-wheel'>
									<WheelLoading theme='light' />
								</div>
							</div>
				}
			</div>
		)
	}
}

ImageCropper.propTypes = {
	value: PropTypes.shape({
		matrix: PropTypes.arrayOf(PropTypes.number),
		icon: PropTypes.shape({
			id: PropTypes.number,
			uploadId: PropTypes.number,
			versions: PropTypes.arrayOf(PropTypes.string),
		}),
	}).isRequired,
	discardContentHandler: PropTypes.func,
	imageLoadHandler: PropTypes.func,
	changeImageMatrixHandler: PropTypes.func,
}

export default CSSModules(ImageCropper, styles, { allowMultiple: true })
